import { apiClient } from '../apiClient';
import { handleRequest } from '../apiWrapper';
import type { AssetPricesResponse } from '@/shared/types';

export const getAssetPrices = async (
  asset: string
): Promise<AssetPricesResponse> => {
  const request = () => apiClient.get(`/assets/${asset}/prices`);
  const response = await handleRequest<AssetPricesResponse>(request);
  return response.data;
};
